<template>
  <div class="flex flex-col sm:flex-row mb-6 md:mb-8 gap-3 sm:gap-5">
    <slot />
  </div>
</template>
